import React from "react";
import { RaisedButton } from "material-ui";

import Note from "./note.jsx";

class AddNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inCreateMode: false
    };
  }

  render() {
    if (this.state.inCreateMode || this.props.isCreating) {
      return (
        <Note
          isNew={true}
          isSaving={this.props.isCreating}
          person={this.props.person}
          order={this.props.order}
          onCreate={() => this.setState({ inCreateMode: false })}
          onCancel={() => this.setState({ inCreateMode: false })}
        />
      );
    }

    return (
      <RaisedButton
        style={{ marginBottom: "1em" }}
        primary={true}
        label="Add new note"
        onTouchTap={() => this.setState({ inCreateMode: true })}
      />
    );
  }
}

export default AddNote;



// WEBPACK FOOTER //
// ./src/app/components/partials/notes/add-note.jsx